import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Image from '@divvy-web/skylab.image'

import MarketingPill from './MarketingPill'
import styles from './styles.module.scss'

export interface MarketingContentProps {
  image: {
    alt: string
    src: string
    isRounded?: boolean
  }
  pillText: React.ReactNode
  footer?: React.ReactNode
}

const MarketingContent = ({
  image: { alt, src, isRounded = false },
  pillText,
  footer,
  children,
}: React.PropsWithChildren<MarketingContentProps>) => {
  const [getClassName, makeTestId] = useNameFormatter('MarketingContent')

  return (
    <div className={`${styles[getClassName('')]} dd-privacy-allow`}>
      <div className={styles[getClassName('content-wrapper')]}>
        <MarketingPill text={pillText} />
        <div
          className={styles[getClassName('content')]}
          data-testid={makeTestId('content')}
        >
          {children}
        </div>
        {isRounded && <div className={styles[getClassName('divider')]}></div>}
        {footer && (
          <div
            className={styles[getClassName('footer')]}
            data-testid={makeTestId('footer')}
          >
            {footer}
          </div>
        )}
      </div>
      <div className={styles[getClassName(`${isRounded ? 'rounded-' : ''}image-wrapper`)]}>
        <Image
          alt={alt}
          className={styles[getClassName(`${isRounded ? 'rounded-' : ''}image`)]}
          src={src}
        />
      </div>
    </div>
  )
}

export default MarketingContent
